export function initAlbums() {
  $("figure.album").each((_i, album) => {
    // Quand on clique sur le texte de description d'un album, on simule un clic
    // sur la première image pour ouvrir la lightbox.
    $(album)
      .find("figcaption")
      .on("click", (event) => {
        $(event.target)
          .parents(".album")
          .first()
          .find(".premier-doc a")
          .click();
      })
      .addClass("bound");
  });
}
